
routes.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider']
import GlobalConfig from '../../../globals/globalConfig.json'
export default function routes ($stateProvider, $urlRouterProvider, $locationProvider) {
  $locationProvider.html5Mode(true)
  $stateProvider
    .state('generalSettings', {
      abstract: false,
      url: '/app/generalSettings',
      redirectTo: 'generalSettings.main',
      views: {
        '': {
          template: require('../../../layout/layout.html')
        },
        'content': {
          template: require('../../../layout/content.html')
        },
        'aside': {
          template: require('../../../layout/aside.html'),
          controller: 'AsideCtrl'
        },
        'header': {
          template: require('../../../layout/header.html'),
          controller: 'HeaderCtrl'
        },
        'chatbox': {
          template: require('../chatbox/chatbox.html'),
          controller: 'ChatboxController',
          controllerAs: 'chatbox'
        },
        'footer': {
          template: require('../../../layout/footer.html')
        }
      },
      data: {displayName: 'Inicio'}
    })
    .state('generalSettings.main', {
      abstract: false,
      url: '/main',
      template: require('./index.html'),
      data: {
        displayName: 'Inicio',
        order: 0,
        siblings: [
          {
            name: 'generalSettings.notificationsManagement',
            order: 1
          },
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      }
    })
    .state('generalSettings.listParams', {
      abstract: false,
      url: '/parameters',
      template: require('./parameters/listParams.html'),
      controller: 'listParamsCtrl',
      controllerAs: 'listParams',
      data: {
        displayName: 'Parámetros de listas',
        rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
        order: 2,
        siblings: [
          {
            name: 'generalSettings.notificationsManagement',
            order: 1
          },
          {
            name: 'generalSettings.users',
            order: 3
          },
          {
            name: 'generalSettings.listSubject',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
            order: 4
          }
        ]
      }
    })
    .state('generalSettings.listSubject', {
      abstract: false,
      url: '/listSubject',
      template: require('./subjects/list/listSubject.html'),
      controller: 'ListSubjectCtrl',
      controllerAs: 'subjectListVM',
      data: {
        displayName: 'Asignaturas médico quirúrgicas',
        rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
        order: 4,
        siblings: [
          {
            name: 'generalSettings.notificationsManagement',
            order: 1
          },
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          }
        ]
      }
    })
    .state('generalSettings.createSubject', {
      abstract: false,
      url: '/createSubject',
      template: require('./subjects/create/createSubject.html'),
      controller: 'createSubjectCtrl',
      controllerAs: 'createSubject',
      data: {
        displayName: 'Asignaturas médico quirúrgicas',
        rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
        order: 4,
        siblings: [
          {
            name: 'generalSettings.notificationsManagement',
            order: 1
          },
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          }
        ]
      }
    })
    .state('generalSettings.editSubject', {
      abstract: false,
      url: '/editSubject/:subjectId',
      template: require('./subjects/create/createSubject.html'),
      controller: 'createSubjectCtrl',
      controllerAs: 'createSubject',
      data: {
        displayName: 'Asignaturas médico quirúrgicas',
        rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.unitAdmin, GlobalConfig.userRolesIds.gerencialConsultant],
        order: 4,
        siblings: [
          {
            name: 'generalSettings.notificationsManagement',
            order: 1
          },
          {
            name: 'generalSettings.listParams',
            rolesAllowed: [GlobalConfig.userRolesIds.generalAdmin,GlobalConfig.userRolesIds.workPlanAdmin],
            order: 2
          },
          {
            name: 'generalSettings.users',
            order: 3
          }
        ]
      }
    })
}



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/generalSettings.route.js